var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07078 18.01L4.0345 18.0465L4.00216 18.0866L1.73381 20.8967L1.69385 20.9462C1.51395 21.0394 1.28469 21.0115 1.13429 20.8627C0.960636 20.6909 0.955397 20.4198 1.11858 20.242L3.76113 17.9363L3.76115 17.9363L3.76694 17.9312L3.83637 17.8696C3.86647 17.8499 3.90316 17.8384 3.94199 17.8384C3.99276 17.8384 4.03947 17.8579 4.07292 17.8897C4.10574 17.9248 4.10502 17.9755 4.07078 18.01ZM21 9.4354C21 11.6691 20.1032 13.8136 18.5034 15.3964C16.9032 16.9795 14.7306 17.8708 12.4631 17.8708C7.73815 17.8708 3.92616 14.0841 3.92616 9.4354C3.92616 4.78672 7.73815 1 12.4631 1C17.188 1 21 4.78672 21 9.4354Z",
    fill: "white",
    stroke: "#B7B7B7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.31def9903a07c5b1bdc8b2c1eefe3145.svg";
export { ForwardRef as ReactComponent };